import actions from "./actions";
import { LightboxType } from "./options";

const initState = {
    visible: false,
    currentIndex: null,
    lightboxType: null,
    files: [],
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.LIGHTBOX_OPEN:
            return {
                ...state,
                visible: true,
                currentIndex: action.currentIndex,
                lightboxType: action.lightboxType,
                files: action.files,
            };
        case actions.LIGHTBOX_CLOSE:
            switch (state.lightboxType) {
                case LightboxType.TRANSACTION:
                case LightboxType.CONTACT:
                    return {
                        ...initState,
                        files: state.files,
                    };
                case LightboxType.file_manager:
                case LightboxType.pdf_preview:
                default:
                    return {
                        ...initState,
                    };
            }
        case actions.LIGHTBOX_RESET:
            return {
                ...initState,
            };
        case actions.LIGHTBOX_SET_CURRENT_INDEX:
            return {
                ...state,
                visible: true,
                currentIndex: action.currentIndex,
            };
        case actions.LIGHTBOX_SET_FILES:
            return {
                ...state,
                files: action.files,
            };
        default:
            return state;
    }
}
